import { useProductContext } from '../../../contexts/product'
import { useFindLocaleText } from '../../../text-localisation'

const SUMMARY_KEY = 'summary'

export const useProductDetails = () => {
  const [
    {
      product: { variants, id: productId, description },
    },
  ] = useProductContext()

  const localiseText = useFindLocaleText()

  const defaultProductDetails = {
    items: [
      {
        key: SUMMARY_KEY,
        value: description,
        title: localiseText('common.product_details'),
      },
    ],
    productId,
  }

  const { content } = variants[0]

  if (content?.__typename !== 'ProductVariantContent') {
    return defaultProductDetails
  }

  const productDetailsModule = content.modules.find(
    module => module.__typename === 'ProductVariantContentModuleDetails',
  )

  if (!productDetailsModule) {
    return defaultProductDetails
  }

  const { items } = productDetailsModule

  if (!items.find(item => item.key === SUMMARY_KEY)) {
    return defaultProductDetails
  }

  return { items, productId }
}
